export const KEYBOARD_SETTINGS = {
  excludedInputs: 'input:not([type=radio]):not([type=range]):not([type=checkbox]):not([disabled]):not([style*="display: none;"])'
};
